// extracted by mini-css-extract-plugin
export default {"container":"stats-panel_container__VH1dz","title":"stats-panel_title__-AeWs","count":"stats-panel_count__HAw6y"};